import { AUTH_SCHEME } from "./authClient";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const shouldStringifyBody = (body) => {
  if (!body) return false;
  if (typeof body === "string") return false;
  if (typeof FormData !== "undefined" && body instanceof FormData) return false;
  if (typeof Blob !== "undefined" && body instanceof Blob) return false;
  if (typeof ArrayBuffer !== "undefined" && body instanceof ArrayBuffer) return false;
  return typeof body === "object";
};

const prepareRequestInit = (token, options = {}, config = {}) => {
  const headers = new Headers(options.headers || {});
  const authScheme = options.authScheme || config.authScheme || AUTH_SCHEME;

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `${authScheme} ${token}`);
  }

  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }

  const init = { ...options, headers };

  if (init.credentials == null) {
    init.credentials = config.credentials ?? "include";
  }

  if (shouldStringifyBody(init.body)) {
    init.body = JSON.stringify(init.body);
    if (!headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
  } else if (
    typeof FormData !== "undefined" &&
    init.body instanceof FormData &&
    headers.has("Content-Type")
  ) {
    headers.delete("Content-Type");
  }

  return init;
};

export const createAuthorizedFetcher = (token, onUnauthorized, config = {}) => {
  const { requireToken = true, authScheme, credentials } = config;

  if (requireToken && !token) {
    return async () => {
      throw new Error("No auth token");
    };
  }

  return async (url, options = {}) => {
    const controller = new AbortController();
    const init = prepareRequestInit(
      token,
      { ...options, signal: controller.signal },
      { authScheme, credentials }
    );

    let response = await fetch(url, init);
    if (response.status === 401 || response.status === 403) {
      await delay(150);
      response = await fetch(url, init);
      if (response.status === 401 || response.status === 403) {
        if (typeof onUnauthorized === "function") {
          await onUnauthorized();
        }
        throw new Error("Unauthorized");
      }
    }

    return response;
  };
};
